/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Pratik Poudel | LLM Inference & KV-Cache Research",
  description:
    "PhD candidate at FIU researching KV-cache compression and LLM inference efficiency. Built CacheCraft and NeSyKV, operates vLLM/SGLang serving at 70B–120B scale, and ships AI products like Cortex on the App Store.",
  og: {
    title: "Pratik Poudel Portfolio",
    type: "website",
    url: "https://powerpratik.github.io",
  },
};

//Home Page
const greeting = {
  title: "Pratik Poudel",
  logo_name: "Pratik",
  nickname: "PP ",
  subTitle:
    "I teach LLMs what to forget. My PhD research builds engines — that discover which model's KV cache can be thrown away without losing the plot. By day I serve 70B–120B models on vLLM/SGLang; by night I ship apps like Cortex, a private AI assistant on the App Store. Off-screen, I'm clearing an adventure-sports bucket list one jump at a time.",
  resumeLink:
    "https://drive.google.com/file/d/1-yMAxM9D2ZYuM-CBZJNJzU7Xg1h5qndO/view?usp=sharing",
  portfolio_repository: "https://github.com/powerpratik/masterPortfolio",
  githubProfile: "https://github.com/powerpratik",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/powerpratik",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/pratik-poudel-/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Google Scholar",
    link:
      "https://scholar.google.com/citations?hl=en&view_op=search_authors&mauthors=Pratik+Poudel",
    fontAwesomeIcon: "fas fa-graduation-cap",
    backgroundColor: "#4285F4",
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UChSHHRV7ddv7SPbXYEe0ZbQ",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:ppoud001@fiu.edu",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/pratik__poudel",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
];

const skills = {
  data: [
    {
      title: "LLM Inference & KV-Cache Research",
      fileName: "DataScienceImg",
      skills: [
        "⁍ KV-cache eviction for long-context LLMs across both prefill and decode: CacheCraft/FRC leads the strongest single-pass prefill baseline by up to +19 RULER points at 88% compression; NeSyKV (MLSys '26 YPS) beats StreamingLLM by up to 1.7 PPL at 94% cache reduction across 15 LLMs",
        "⁍ Serving and profiling with vLLM (PagedAttention) and SGLang (RadixAttention, prefix caching), FlashAttention/FlashInfer, and quantization for serving (FP8, INT4, GPTQ, AWQ)",
        "⁍ Evaluation at scale: Llama 3.1/3.2 (1B–70B), Qwen 2.5/3, Mistral, Gemma, GPT-OSS 120B on RULER 4k/8k, perplexity, and long-context & agentic workloads",
      ],
      softwareSkills: [
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            backgroundColor: "transparent",
            color: "#FFD21E",
          },
        },
        {
          skillName: "Ollama",
          fontAwesomeClassname: "simple-icons:ollama",
          style: {
            backgroundColor: "white",
            color: "#000000",
          },
        },
        {
          skillName: "NVIDIA",
          fontAwesomeClassname: "simple-icons:nvidia",
          style: {
            color: "#76B900",
          },
        },
      ],
    },
    {
      title: "AI & Systems Infrastructure",
      fileName: "CloudInfraImg",
      skills: [
        "⁍ Architect and operator of a lab-level vLLM/SGLang/Ollama inference stack serving Llama 3-70B and GPT-OSS 120B to NSF-funded research groups",
        "⁍ Contributor to the architecture and design of the department's cloud-supporting AI infrastructure, built on a Ceph distributed-storage cluster that won an NSF supplement-funding award",
        "⁍ Distributed systems background: caching frameworks (CaaS), storage-trace characterization, Kubernetes/Docker/Proxmox-based deployments on Linux",
      ],
      softwareSkills: [
        {
          skillName: "Ceph",
          fontAwesomeClassname: "simple-icons:ceph",
          style: {
            color: "#EF5C55",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Proxmox",
          fontAwesomeClassname: "simple-icons:proxmox",
          style: {
            color: "#E57000",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#FCC624",
          },
        },
      ],
    },
    {
      title: "Applied AI Engineering & Automation",
      fileName: "FullStackImg",
      skills: [
        "⁍ Shipped Cortex, a private AI assistant for iOS on the Apple App Store, integrating locally hosted LLMs for on-device, private inference",
        "⁍ Built a personal LLM hub: Ollama-hosted Llama 3-70B and GPT-OSS 120B wired into n8n for a research-assistant agent and a real-time RSS-to-Discord news pipeline",
        "⁍ I automate my daily workflow — from deploying this website with a 3-letter trigger word via Raycast to meeting-transcript summarizers and lab-to-laptop file sync tools",
      ],
      softwareSkills: [
        {
          skillName: "Swift",
          fontAwesomeClassname: "simple-icons:swift",
          style: {
            color: "#F05138",
          },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            color: "#009688",
          },
        },
        {
          skillName: "n8n",
          fontAwesomeClassname: "simple-icons:n8n",
          style: {
            color: "#EA4B71",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Bash Scripting",
          fontAwesomeClassname: "simple-icons:gnubash",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Raycast",
          fontAwesomeClassname: "simple-icons:raycast",
          style: {
            backgroundColor: "#000000",
            color: "#FF6363",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Florida International University",
      subtitle: "PhD in Computing & Information Sciences",
      logo_path: "fiu_logo.png",
      alt_name: "Florida International University",
      duration: "2020 - Present | CGPA 3.87/4.0",
      descriptions: [
        "⁍ Researching KV-cache compression and inference efficiency for long-context LLMs across both prefill and decode phases at ModLab & SyLab.",
        "⁍ Built CacheCraft, an LLM-guided code-evolution engine that auto-discovers prefill KV-cache eviction policies — its discovered scorer FRC leads the strongest evaluated baseline by up to +19 RULER points at 88% KV compression.",
        "⁍ Lead author on NeSyKV (MLSys '26 YPS poster): neuro-symbolic, architecture-specific decode-phase eviction that beats StreamingLLM by up to 1.7 PPL at 94% cache reduction across 15 open-weight LLMs.",
        "⁍ Fully funded via NSF-supported research projects (2020–2025); also serve the department by architecting and operating its LLM inference and storage infrastructure.",
      ],
      website_link: "https://www.fiu.edu/",
    },
    {
      title: "Florida International University",
      subtitle: "MS in Computing & Information Sciences",
      logo_path: "fiu_logo.png",
      alt_name: "Florida International University",
      duration: "2020 - 2024 | CGPA 3.87/4.0",
      descriptions: [
        "⁍ Earned en route to the PhD with coursework spanning Storage Systems, Algorithms, Artificial Intelligence, Graph Machine Learning, Data Mining, and Visualization.",
        "⁍ Early research focused on distributed storage and caching: unified data-center caching (HotStorage '21) and ML-based storage-trace characterization, compression, and synthesis (SIGSIM-PADS '23, lead author).",
      ],
      website_link: "https://www.fiu.edu/",
    },
    {
      title: "Kathmandu University",
      subtitle: "B.E. in Computer Engineering",
      logo_path: "ku_logo.png",
      alt_name: "Kathmandu University",
      duration: "2015 - 2019 | CGPA 3.63/4.0",
      descriptions: [
        "⁍ Core software engineering curriculum: Data Structures, Algorithms, DBMS, Operating Systems, ML & AI, and the software development lifecycle.",
        "⁍ Organizing committee member of one of Nepal's biggest university-level IT events.",
        "⁍ Finalist in a semester project competition with Nepali Braille — an Arduino/Android assistive hardware project helping the visually impaired learn and interface through Braille.",
      ],
      website_link: "https://www.ku.edu.np",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "OpenAI Parameter Golf Compute Award",
      subtitle: "2026 — $1,000 in GPU compute for parameter-golf submissions on the OpenAI open-source LM leaderboard",
      logo_path: "openai_logo.svg",
      certificate_link: "https://openai.com",
      alt_name: "OpenAI",
      color_code: "#FFFFFF",
    },
    {
      title: "Morgridge Institute Hackathon Grant",
      subtitle: "2024 — $1,000; connected our distributed storage system to the OSPool national cyberinfrastructure",
      logo_path: "morgridge_logo.png",
      certificate_link: "https://morgridge.org",
      alt_name: "Morgridge Institute",
      color_code: "#FFFFFF",
    },
    {
      title: "ACM SIGSIM-PADS Travel Grant",
      subtitle: "2023 — $1,000 to present an oral talk and poster at ACM SIGSIM-PADS",
      logo_path: "acm_logo.svg",
      certificate_link: "https://dl.acm.org/doi/10.1145/3573900.3593632",
      alt_name: "ACM",
      color_code: "#FFFFFF",
    },
    {
      title: "FIU PhD Assistantship",
      subtitle: "2020 – 2025 — full funding via NSF-supported research projects",
      logo_path: "fiu_logo.png",
      certificate_link: "https://www.cis.fiu.edu",
      alt_name: "FIU",
      color_code: "#FFFFFF",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Research, Work and Volunteership",
  description:
    "Five years of research experience spanning LLM inference efficiency and distributed storage systems, with publications at MLSys YPS, HPDC, PEARC, SIGSIM-PADS, and HotStorage — plus invited talks and posters at PEARC '25 (oral), AI2ES/AMS 2025, FIU Tech Summit 2024, SIGSIM-PADS '23 (oral), and FCRC '23.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Graduate Research Assistant — LLM Inference & KV-Cache Eviction",
          company: "ModLab & SyLab, Florida International University",
          company_url: "https://people.cis.fiu.edu/liux/",
          logo_path: "fiu_logo.png",
          duration: "August 2023 - Present",
          location: "Miami, Florida",
          description:
            "Built CacheCraft, an LLM-guided code-evolution engine that auto-discovers prefill KV-cache eviction policies; its discovered scorer FRC retains 84.5 RULER avg at 88% compression on Llama-3.1-8B vs. 65.7 for the next-best baseline, ranking first in 12 of 20 RULER grid cells. Lead author on NeSyKV (MLSys '26 YPS), distilling per-architecture attention fingerprints into depth-3 decision trees for decode-phase eviction — beats StreamingLLM by up to 1.7 PPL at 94% cache reduction across 15 LLMs. Also profile RadixAttention prefix-cache behavior under agentic workloads in SGLang, and architect/operate the lab's vLLM/SGLang inference stack serving Llama 3-70B and GPT-OSS 120B to NSF-funded research groups.",
          color: "#0879bf",
        },
        {
          title: "Graduate Research Assistant — Distributed Storage & Caching",
          company: "ModLab & SyLab, Florida International University",
          company_url: "https://people.cis.fiu.edu/liux/",
          logo_path: "fiu_logo.png",
          duration: "August 2020 - July 2023",
          location: "Miami, Florida",
          description:
            "Worked on unified caching for distributed storage systems (HotStorage '21) and ML-based storage-trace characterization, compression, and synthesis (SIGSIM-PADS '23, lead author). Built CaaS, a distributed caching framework with a unified API across block/file/KV/object backends on the FIU Ceph cluster — the substrate for later cache-eviction and storage-translation experiments.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Plan Analytics Intern",
          company: "Deerwalk Institute of Technology.",
          company_url: "https://deerwalk.edu.np/DWIT/",
          logo_path: "dwit_logo.jpeg",
          duration: "July - September, 2019",
          location: "Kathmandu, Nepal",
          description:
            "Worked as an Intern on a major product focused in visualization of data and providing actionable insights using tools like charts, graphs etc",
          color: "#000000",
        },
      ],
    },
    {
      title: "Volunteering",
      experiences: [
        {
          title: "One week program on Software Development ",
          company: "Fusemachines",
          company_url: "https://fusemachines.com",
          logo_path: "fuse_machines.png",
          duration: "2015",
          location: "Kathmandu, Nepal",
          description:
            "Got a chance to explore the software development cycle in the orgranization. From the integration of the front end tools(like ember js), db tools(like mongo db) and backend(like node) , I got a chance to learn about how a software production system worked in tandem with various entities",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Publications and Projects",
  description:
    "Research that makes long-context LLM inference cheaper, and the things I build with what's left of the GPU budget — from an App Store assistant to a 120B-model homelab.",
  avatar_image_path: "projects_image.svg",
};

const selectedProjects = {
  title: "Selected Projects",
  description:
    "Things I've shipped outside of papers — apps, infrastructure, and the occasional compute-award-winning experiment.",
  data: [
    {
      id: "cortex-ios",
      name: "Cortex — Private AI Assistant (iOS)",
      createdAt: "2026-01-15T00:00:00Z",
      description:
        "Published on the Apple App Store: an assistant that runs against locally hosted LLMs, so conversations never leave your hardware.",
      url:
        "https://apps.apple.com/us/app/cortex-private-ai-assistant/id6759742402",
      languages: [
        { name: "Swift", iconifyClass: "logos-swift" },
        { name: "Python", iconifyClass: "logos-python" },
      ],
    },
    {
      id: "parameter-golf",
      name: "Parameter Golf",
      createdAt: "2026-04-15T00:00:00Z",
      description:
        "Train the smallest language model that fits in 16MB — my submissions to OpenAI's open-source LM leaderboard earned a $1,000 compute award.",
      url: "https://github.com/powerpratik/parameter-golf",
      languages: [{ name: "Python", iconifyClass: "logos-python" }],
    },
    {
      id: "local-llm-hub",
      name: "Local LLM Hub & Agentic Workflows",
      createdAt: "2025-06-01T00:00:00Z",
      description:
        "Personal serving stack: Ollama-hosted Llama 3-70B and GPT-OSS 120B wired into n8n — a research-assistant agent and a real-time RSS-to-Discord news pipeline, all on local models.",
      url: "https://github.com/powerpratik",
      languages: [
        { name: "Python", iconifyClass: "logos-python" },
        { name: "Docker", iconifyClass: "logos-docker-icon" },
      ],
    },
    {
      id: "caas",
      name: "CaaS — Caching-as-a-Service",
      createdAt: "2021-09-01T00:00:00Z",
      description:
        "Distributed caching framework with a unified API across block, file, KV, and object backends — the substrate for cache-eviction and storage-translation experiments on FIU's Ceph cluster.",
      url: "https://dl.acm.org/doi/10.1145/3465332.3470884",
      languages: [
        { name: "Python", iconifyClass: "logos-python" },
        { name: "C++", iconifyClass: "logos-c-plusplus" },
      ],
    },
  ],
};

const publicationsHeader = {
  title: "Publications",
  description:
    "Peer-reviewed work spanning LLM inference efficiency, research cyberinfrastructure, and storage systems — at MLSys YPS, HPDC, PEARC, SIGSIM-PADS, and HotStorage.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "nesykv-mlsys26",
      name: "NeSyKV: Neuro-Symbolic Architecture-Specific KV-Cache Eviction for LLM Inference",
      createdAt: "2026-05-01T00:00:00Z",
      description:
        "P. Poudel, Y. Wu, S. Jha, J. Liu — MLSys '26 Young Professionals Symposium (poster). Beats StreamingLLM by up to 1.7 PPL at 94% cache reduction across 15 open-weight LLMs.",
      url: "https://mlsys.org/",
    },
    {
      id: "cachecraft-2026",
      name: "CacheCraft: LLM-Guided Discovery of KV Cache Eviction Policies",
      createdAt: "2026-01-01T00:00:00Z",
      description:
        "P. Poudel et al. — under submission. Discovered scorer FRC leads the strongest evaluated single-pass prefill baseline by up to +19 RULER points at 88% KV compression.",
      url:
        "https://scholar.google.com/citations?hl=en&view_op=search_authors&mauthors=Pratik+Poudel",
    },
    {
      id: "raptor-hpdc25",
      name: "RAPTOR: Reconfigurable Advanced Platform for Transdisciplinary Open Research",
      createdAt: "2025-07-20T16:26:54Z",
      description: "H. Najafi, P. Poudel, K. Bahreini et al. — HPDC '25, ACM.",
      url: "https://sites.google.com/view/flexscience",
    },
    {
      id: "pearc25-pipeline",
      name: "A Scalable Framework for Heterogeneous Environmental Data Management Using Smart Data Pipeline",
      createdAt: "2025-07-24T16:26:54Z",
      description: "P. Poudel, B. Guan, N. Sanchez et al. — PEARC '25, ACM (oral).",
      url: "https://dl.acm.org/doi/10.1145/3708035.3736017",
    },
    {
      id: "agentic-pipeline-journal",
      name: "Agentic AI in Smart Data Pipeline for Environmental Research Data Management and Visualization",
      createdAt: "2025-06-01T00:00:00Z",
      description: "B. Guan, A. W. Barok De Souza, P. Poudel et al. — journal, in press, 2025.",
      url:
        "https://scholar.google.com/citations?hl=en&view_op=search_authors&mauthors=Pratik+Poudel",
    },
    {
      id: "10.1145/3573900.3593632",
      name: "Storage System Trace Characterization, Compression, and Synthesis using Machine Learning",
      createdAt: "2023-06-01T16:26:54Z",
      description:
        "P. Poudel — ACM SIGSIM-PADS '23 (extended abstract, lead author), presented as part of FCRC '23.",
      url: "https://dl.acm.org/doi/10.1145/3573900.3593632",
    },
    {
      id: "10.1145/3465332.3470884",
      name: "Unifying the Data Center Caching Layer: Feasible? Profitable?",
      createdAt: "2021-07-01T16:26:54Z",
      description:
        "L. V. Rodriguez, A. Gonzalez, P. Poudel, R. Rangaswami, J. Liu — HotStorage '21, ACM.",
      url: "https://dl.acm.org/doi/10.1145/3465332.3470884",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "prat.png",
    description:
      "The fastest way to reach me is email: ppoud001@fiu.edu. I'm happy to talk about LLM inference efficiency, KV-cache research, AI infrastructure, or anything I've built. Scroll down for my blog ⤓ or check my YT where I complete my bucketlist of adventure sports.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Check out my blog: It's a WIP but I try to keep it simple and share my utility based automation works there.",
    link: "./blog",
    avatar_image_path: "blogs_image.svg",
  },
  TrimTimelineSupportSection: {
    title: "Trim Timeline Support",
    subtitle: "Support for Trim Timeline app",
    link: "./trimtimelinesupport",
  },
  addressSection: {
    title: "Address",
    subtitle: "",
    locality: "#",
    country: "US",
    region: "#",
    postalCode: "#",
    streetAddress: "#",
    avatar_image_path: "address_image.svg",
    location_map_link: "#",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  selectedProjects,
  publicationsHeader,
  publications,
  contactPageData,
};
